import { z } from "zod";
export const ExternalAccountType = z.enum([
    "credit",
    "depository",
    "investment",
    "loan",
    "savings",
    "checking",
]);
//Providers
export const ExternalAccountProvider = z.enum(["manual", "plaid"]);
//Details
export const ExternalAccountDetail = z.enum([
    "ManualAccountDetails",
    "PlaidAccountDetails",
]);
//Funding Status
export const ExternalAccountFundingStatus = z.enum([
    "active",
    "inactive",
    "pending",
    "planning",
]);
//Connection health
export const ConnectionHealth = z.enum([
    "healthy",
    "unavailable",
    "degraded",
    "down",
]);
//Link Status
export const PlaidLinkStatus = z.enum(["valid", "expired", "error"]);
export const LinkId = z.custom((val) => typeof val === "string");
export const fundingAccountTypeOptions = ["checking", "savings"];
export const FundingAccountTypeOption = z.enum(fundingAccountTypeOptions);
//# sourceMappingURL=types.js.map